import PageViewCounter from 'components/Help/PageViewCounter/PageViewCounter';

export default PageViewCounter;
